<template>
  <chart-card :loading="loading" :title="title">
    <template slot="total">
       <span :title="total | NumberFormat">
        <count-to 
          :startVal='numberFomartToSample(beforeTotal, 6)' 
          :endVal='numberFomartToSample(total, 6)'
          :duration='countToDuration' 
          :decimals="total.toString().length > 6 ? 2 : 0"
        />
      </span>
      <span style="font-size: 14px">{{total.toString().length > 6 ? $t('home.unitWan') : ''}}</span>
    </template>
    <template slot="default">
      <span 
        v-for="(sub, index) in subContent" 
        :key="sub.title"
        class="sub-number"
        :class="'sub-' + index"
        style="margin-right: 16px;"
      > 
        <span>{{sub.title}}：</span>
        <span :title="sub.number | NumberFormat">
          <count-to 
            :startVal='numberFomartToSample(beforeNumber[index], 4)' 
            :endVal='numberFomartToSample(sub.number, 4)' 
            :duration='countToDuration' 
            :decimals="sub.number.toString().length > 4 ? 2 : 0"
          />
        </span>
        <span>{{sub.number.toString().length > 4 ? $t('home.unitWan') : ''}}{{sub.unit}}</span>
      </span>
    </template>
    
    <template slot="graphs">
      <pie-chart :infoData="pieData" />
    </template>
  </chart-card>
</template>

<script>
import { ChartCard } from '@/components/Charts'
import PieChart from './PieChart'
import countTo from 'vue-count-to'
import { numberFomartToSample } from '@/utils/utils'

export default {
  name: 'ChartPanel',
  components: { ChartCard, PieChart, countTo },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    total: {
      type: Number,
      default: 0
    },
    subContent: {
      type: Array,
      default: () => { return [] }
    }
  },
  data () {
    return {
      countToDuration: 3000,
      beforeTotal: 0,
      beforeNumber: new Array(this.subContent.length).fill(0),

      pieData: []
    }
  },
  watch: {
    total: function(newVal, oldVal) {
      this.beforeTotal = oldVal || 0
    },

    subContent: function (newVal, oldVal) {
      oldVal.forEach((sub, index) => {
        this.beforeNumber[index] = sub.number
      })

      this.pieData = newVal.map(item => {
        return {
          item: item.title, count: item.number
        }
      })
    }
  },
  computed: {},
  methods: {
    numberFomartToSample
  }
}
</script>

<style lang="less" scoped>
.sub-number{
  white-space: nowrap;
  position: relative;
  padding-left: 15px;
  display: block;
}
.sub-number:before{
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  left: 0;
  top: 5px;
}
.sub-number.sub-0:before{
  background-color: #72b1fd;
}
.sub-number.sub-1:before{
  background-color: #74d4d4;
}

</style>
